export default __webpack_public_path__ + "static/cndf-lab2-c4d781b15714dcfd5f6b4e4936341274.jpg";